module.exports = __webpack_public_path__ + "img/Pascaline.ba8cadb5.png";